<template>
  <div class="w-100">
    <div class="d-flex flex-column">

      <HeroHeader></HeroHeader>

      <Statistics type="auto"></Statistics>

      <OurServices id="outServices"></OurServices>

      <CTASection title="Paruošti pradėti?" text="Susisiekite su mumis dar šiandien ir gaukite nemokamą konsultaciją"></CTASection>

      <Testimonials type="auto"></Testimonials>

      <OurAdvantages id="ourAdvantages"></OurAdvantages>

      <WhoWeAre></WhoWeAre>

      <EasySteps></EasySteps>

      <FAQ type="auto"></FAQ>

      <Map></Map>

      <Contact id="contact"></Contact>

      <SolarGallery></SolarGallery>

      <Footer type="auto"></Footer>

      <FloatingPhoneButton></FloatingPhoneButton>

      <ScrollToTop></ScrollToTop>

    </div>
  </div>
</template>

<script>
import HeroHeader from "@/views/auto/HeroHeader";

import OurAdvantages from "@/views/auto/OurAdvantages";
import OurServices from "@/views/auto/OurServices";
import WhoWeAre from "@/views/auto/WhoWeAre";
import EasySteps from "@/views/auto/EasySteps";
import Footer from "@/views/auto/Footer";
import Map from "@/views/Map";
import Contact from "@/views/auto/Contact";
import ScrollToTop from "@/components/ScrollToTop";
import SolarGallery from "@/components/SolarGallery";
import Statistics from "@/components/Statistics";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import FloatingPhoneButton from "@/components/FloatingPhoneButton";
import CTASection from "@/components/CTASection";

export default {
  name: "Autoservice",
  components: {
    ScrollToTop,
    HeroHeader,
    OurAdvantages,
    OurServices,
    WhoWeAre,
    EasySteps,
    Footer,
    Contact,
    Map,
    SolarGallery,
    Statistics,
    Testimonials,
    FAQ,
    FloatingPhoneButton,
    CTASection,
  },
  setup(){

  }
}
</script>

<style scoped>

</style>